import _extends from "@babel/runtime-corejs2/helpers/extends";
import React from "react";
import styled from 'styled-components';
/** Can grow to be anything we want this to be. First iteration, is used for button (NOT LINK) with an icon */

var Input = function Input(props) {
  return /*#__PURE__*/React.createElement(StyledInput, _extends({}, props, {
    className: "help-text-input-muted form-control"
  }));
};

var StyledInput = styled.input.withConfig({
  displayName: "Input__StyledInput",
  componentId: "sc-3ne7q0-0"
})(["", " svg{margin:7px 0 0 -18px;}"], function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? "\n      ::placeholder {\n        opacity: 0.3 !important;\n      }\n        " : '';
});
export default Input;